import MUIDataTable from "mui-datatables";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EditIcon from "@mui/icons-material/Edit";
import { Navigate, useNavigate } from "react-router-dom";

function OffBatchComponent({
  setSelectedBatch,
  selectedBatch,
  programfilter,
  setprogramfilter,
  admissionfilter,
  setadmissionfilter,
  setSelectedCourse,
}) {
  let [batchdata, setbatchdata] = useState([]);
  let [batchs, setbatchs] = useState([]);
  let [isMounted, setIsMounted] = useState(true);
  let [selectedrows, setselectedrows] = useState([]);
  const navigate = useNavigate();
  let { setError } = useContext(CourseAssignmentContext);

  let api = useAxiosPrivate();

  let columns = [
    {
      name: "Batch Id",
      options: {
        filter: false,
      },
    },
    {
      name: "Batch Year",
      options: {
        filter: true,
      },
    },
    {
      name: "Semester Term",
      options: {
        filter: true,
      },
    },
    {
      name: "No. of Students",
      options: {
        filter: true,
      },
    },
    {
      name: "Admission Type",
      options: {
        filter: true,
        filterList: admissionfilter,
      },
    },
    {
      name: "Program Type",
      options: {
        filter: true,
        filterList: programfilter,
      },
    },
    {
      name: "createdAt",
      options: {
        filter: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Action",
      options: {
        filter: false,
        sort: false,
      },
      // customBodyRender(value,tableMeta,updateValue){
      //     return (
      //         <span style={{cursor:"pointer"}}>
      //         {value}

      //         </span>
      //     )
      // }
    },
  ];
  async function getBatchs(signal) {
    try {
      let respdata = await api.get(`courseallocation/offbatches`, {
        signal,
      });
      console.log("batches", respdata.data);

      isMounted && setbatchs(respdata.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  }

  function alignBatchData() {
    let arr = [];

    batchs.forEach((batch) => {
      console.log(batch);
      let arrfordata = [
        batch.id,
        batch.batch_year,
        batch.Semester.semester_term,
        batch.stud_number,
        batch.admission_type,
        batch.program_type,
        batch.createdAt,
        <EditIcon
          onClick={() => {
            console.log(batch.id);
            navigate("/courseAssignment/updateOffBatch", {
              state: { updateId: batch.id },
            });
          }}
          sx={{
            cursor: "pointer",
          }}
        />,
      ];

      arr.push(arrfordata);
    });

    setbatchdata(arr);
  }

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getBatchs(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  useEffect(() => {
    alignBatchData();
  }, [batchs]);

  function handleSelection(selecteddata) {
    let arr = [];
    selecteddata.forEach((row) => {
      arr.push(batchdata[row.index]);
      setselectedrows([row.index]);
    });

    if (arr.length > 0) {
      let filterbatchs = batchs.filter((b) => b.id == arr[0][0]);
      console.log(filterbatchs);

      setSelectedBatch([filterbatchs[0]]);
    } else {
      setSelectedBatch([]);
    }
  }

  let options = {
    print: "true",
    download: "true",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    selectableRows: true,
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      handleSelection(allRowsSelected);
    },
    sortOrder: {
      name: "createdAt",
      direction: "desc",
    },
    onFilterChange: (changedColumn, filterList) => {
      console.log(changedColumn);
      console.log(filterList);
      setadmissionfilter(filterList[4]);
      setprogramfilter(filterList[5]);

      setSelectedCourse([]);
    },
    rowsSelected: selectedrows,
  };

  useEffect(() => {
    if (selectedBatch.length <= 0) {
      setselectedrows([]);
    }
  }, [selectedBatch]);

  return (
    <div style={{ width: "52%" }}>
      <MUIDataTable
        options={options}
        columns={columns}
        data={batchdata}
        title="Batch List"
      />
    </div>
  );
}

export default OffBatchComponent;
